import useLocation from 'react-use/lib/useLocation'

export default function useDiscountToken(): string | null {
  const { search } = useLocation()
  return new URLSearchParams(search?.substring(1) ?? '').get('dt')
}
